<div
  class="container mx-0"
  [ngClass]="{
    'active': value == status.ACTIVE || value == status.PAID || value == status.PARTIALLY_PAID,
    'inActive': value == status.INACTIVE,
    'pending': value == status.PENDING || value == status.ASSIGNED || value == status.NOT_READY || value === 'NotReady',
    'registered': value == status.REGISTERED || value == status.WAITING_FOR_PAYMENT,
    'rejected': value == status.REJECTED,
    'available': value == status.AVAILABLE || value == status.PASS || value === 'Free',
    'notAvailable': value == status.NOT_AVAILABLE || value == status.FAILED || value ==='Busy'
  }"
>
  <span>{{ "Enum.Status." + value | translate }}</span>
</div>
